import { GET_SUGGESTIONS, CLEAR_SUGGESTIONS } from "../actions/types";

export default (state = { suggestions: [] }, action) => {
  switch (action.type) {
    case GET_SUGGESTIONS:
      return {
        ...state,
        suggestions: action.payload.results
      };
    case CLEAR_SUGGESTIONS:
      return {
        ...state,
        suggestions: []
      };
    default:
      return state;
  }
};
